import React, { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

export const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const location = useLocation()

    useEffect(() => {
        setMenuOpen(false)
    }, [location])
    
    return (
        <header id="top-anchor" className="no-print">
            <div>
                <a href="https://mhcc.maryland.gov/" target="_blank" rel="noopener noreferrer">
                    <img className="logo" src="/logo192.png" alt="mhcc logo" />
                </a>

                <div className="collapsed-menu-bar" onClick={() => setMenuOpen(!menuOpen)}>
                    <div className="menu-icon"></div>
                    <div className="menu-title">Menu</div>
                </div>

                <div id="nav-links">
                    <ul className={menuOpen ? 'main-nav mobile-nav' : 'main-nav'}>
                        <NavLink exact to="/start" className="nav-link">Concept Menu</NavLink>
                        <NavLink to="/results" className="nav-link">My Results</NavLink>
                        <NavLink to="/resources" className="nav-link">Telehealth Resources</NavLink>
                        <a 
                            onClick={() => {
                                gtag('event', 'Download paper tool', {
                                    'event_category': 'download'
                                })
                            }}
                            href="/Telehealth-Readiness-Assessment.pdf" 
                            target="_blank" 
                            className="nav-link download-link"
                        >Paper Tool</a>
                    </ul>
                </div>
            </div>
        </header>
    )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js